var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex justify-space-around"},_vm._l((_vm.ops),function(op){return _c('div',{key:op.value,class:`op-container ${_vm.localOp == op.value ? 'op-selected' : ''}`,on:{"click":function($event){_vm.localOp = op.value}}},[_vm._v(" "+_vm._s(op.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }